import { useErrorContext } from '../../context/ErrorContext';
import MidAddSuppliers from '../../middleware/Supplier/MidAddSuppliers';
import { useState, useParams, FaSearch, Noacountexist, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle, } from '../../common/common';
import MidViewSuppliers from '../../middleware/Supplier/MidViewSuppliers';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import { getInitials } from '../../common/CommonFunctions';
const AddSupplier = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, values, handleChange, handleSubmit, suppliers, isrequested, isconnected, handleselect, reqestedSupllier } = MidAddSuppliers(type);

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];

    }

    // console.log(reqestedSupllier);
    // console.log(suppliers);


    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="grid grid-cols-12">
                    <div className="col-start-1 col-end-13">
                        <div className="border-0 flex-row rounded-xl m-3 p-4 bg-white shadow-xs">
                            <div className=' relative flex flex-col min-w-0 break-words'>
                                <div className="p-3">
                                    <div className="flex flex-row justify-center items-center mb-4">
                                        <div className="flex flex-row justify-between items-center bg-white rounded-b-md overflow-x-hidden sticky top-0 h-15">
                                            <div className="w-full lg:pl-10">
                                                <div className="relative flex flex-row p-2 w-full rounded-md border border-gray-300">
                                                    <FaSearch className="h-5 w-5 absolute left-3 my-2" />
                                                    <input
                                                        type="text"
                                                        name="searchSupplier"
                                                        id="searchSupplier"
                                                        autoComplete="new-password"
                                                        value={values.searchSupplier}
                                                        onChange={handleChange}
                                                        required
                                                        maxLength={10}
                                                        placeholder="Enter Supplier's Code"
                                                        className="w-full lg:w-[400px] bg-transparent pl-10 focus:outline-none pr-6 "
                                                    />
                                                    <Button className="btn btn-primary" onClick={handleSubmit}>Search</Button>
                                                </div>
                                                {error.searchSupplier && (
                                                    <p className="my-2 px-2 text-red-600 text-xs">
                                                        {error.searchSupplier}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div>
                                {(suppliers?.length > 0) ? (suppliers).map((sup, index) => {
                                   
                                    const unique_key = sup.unique_key;
                                    const isAlreadyRequested = reqestedSupllier?.some(r => r.unique_key === unique_key);

                                    return (
                                        <div key={index} className="flex container justify-center m-4">
                                            <div className="rounded-xl p-2 border-2 border-[#d3d3d3] bg-white">
                                                <div className="w-full flex flex-row space-x-2">
                                                    <div className='m-auto'>
                                                        <span className="relative inline-flex items-center justify-center font-medium w-14 h-14 text-[1.25rem] rounded-full !bg-[#3D5EE1] text-[#FFF]">
                                                            {getInitials(sup.company_name)}
                                                        </span>
                                                    </div>

                                                    <div className="flex flex-row justify-between w-full">
                                                        <div className="lg:text-left">
                                                            <h2 className="text-xl font-bold text-zinc-700">
                                                                {sup.company_name?.toUpperCase() || "Company name not provided"}
                                                            </h2>
                                                            <p className="my-2 text-gray-500 font-semibold">
                                                                {sup.address1}, {sup.address2}, {sup.city_name}, {sup.state_name}
                                                            </p>
                                                        </div>
                                                        <div className='p-0'>
                                                            <Button
                                                                className={`btn m-2 ${isrequested ? "bg-sky-500" : "btn-primary"
                                                                    }`}
                                                                onClick={() => handleselect(sup.unique_key)}
                                                                disabled={isrequested || sup.isConnected}
                                                            >
                                                                {sup.isConnected
                                                                    ? "Connected"
                                                                    : isrequested
                                                                        ? "Requested"
                                                                        : "Send Request"}
                                                            </Button>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : (
                                    <div>
                                        {reqestedSupllier?.length === 0 && (
                                            <div className='my-[10%]'>
                                                <center>
                                                    <img src={Noacountexist} />
                                                    <p className='text-gray-400 text-md font-medium'>
                                                        Enter supplier code to reach supplier account
                                                    </p>
                                                </center>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </div>
    )
}

export default AddSupplier